import { FC } from 'react';
import { TFunction } from 'next-i18next';

import { PrivacyPolicyDoc } from '@api/prismic/static-pages/types';
import { hasRichTextContent } from '@lib/slice-machine/richText';
import { Typography } from '@mui/material';
import { ContentSpacer } from '@templates/common/layout/ContentSpacer';
import { CustomRichText } from '@ui/slice-machine/CustomRichText';

interface Props {
  t: TFunction;
  data: PrivacyPolicyDoc['data'] | null;
}

export const PrivacyPolicy: FC<Props> = ({ data }) => {
  return (
    <ContentSpacer maxWidth="md">
      {data?.title && (
        <Typography component="h1" color="primary" fontSize={40}>
          {data.title}
        </Typography>
      )}
      {hasRichTextContent(data?.content) && (
        <CustomRichText render={data?.content} />
      )}
    </ContentSpacer>
  );
};
